import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../@casino/ui/table';
import Title from '../../../../../@casino/ui/title';
import { setGetPresentList } from '../../store/thunk/setGetPresentList';
import {getDate} from '../../../../../@casino/lib/getDate';
import { setPostPresentCancel } from '../../store/thunk/setPostPresentCancel';
import { setPostPresentSuccess } from '../../store/thunk/setPostPresentSuccess';
import { parseLogin } from '../../../../../@casino/lib/parseLogin';

const PresentConfirmation = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetPresentList({
            page: 1,
            rowsPerPage: 10,
            search: ''
        }));
    }, []);

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'date', label: 'Дата'},
        { id: 'amount', label: 'Сумма'},
        { id: 'login', label: 'Логин игрока'},
        { id: 'groups', label: 'Группа выдачи'},
        { id: 'status', label: 'Статус'}, 
    ];
    
    const list = useSelector(state => state.present.list);

    const getRow = (val) => {
        return  val.map((item) => {
            return {
                id: item.id,
                operator: item.operator,
                date: getDate(item.event_date),
                amount: item.amount + ' ₽',
                login: parseLogin(item.user_login),
                groups: item.groups,
                status: item.status && item.message === 'success'
                    ? <span style={{color: 'pink'}}>Уже выдан</span> 
                    : item.status && item.message === 'cancel' ? <span style={{color: 'pink'}}>Отмена выдачи</span>  
                    :
                    <div>
                        <span 
                            style={{cursor: 'pointer', marginRight: 12}} 
                            onClick={() => {
                                dispatch(setPostPresentSuccess({id: item.id})); 
                            }}
                        >Выдать</span>
                        <span style={{cursor: 'pointer'}} onClick={() => {dispatch(setPostPresentCancel({id: item.id}))}}>Отказать</span>
                    </div>
                    
            }
        })
    }

    const row = getRow(list.list)
 
    return (
        <div style={{
            padding: 20,
            paddingTop: 0,
        }}>
            <Title label="Подтверждение подарков"/>
            <div style={{
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
            }}>
                <input 
                    type="text"
                    placeholder="Поиск"
                    style={{
                        padding: 10,
                        background: '#141b33',
                        paddingLeft: 10,
                        border: '1px solid #141b33',
                        color: '#fff',
                        outline: 'none',
                        margin: 10,
                        width: '97.3%'
                    }}
                    // value={search}
                    // onChange={(v) => {
                    //     dispatch(setGroups({
                    //         group: v.target.value,
                    //     }));
                    //     setSearch(v.target.value);
                    // }}
                />
            </div>
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
            }}>
                <TableCasino
                    pagination
                    allPage={list.page}
                    width={1600}
                    perPage={10}
                    columns={columns}
                    rows={row}
                    changePage={(v) => dispatch(setGetPresentList({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetPresentList({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                    }))}
                /> 
            </div>
        </div>
    )
}

export default PresentConfirmation;